import { resources } from '@/mocks/resources';
import ResourceCard from '@/components/feature/ResourceCard';

export default function LatestResources() {
  const latestResources = resources
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2 font-heading">
              最新资源
            </h2>
            <p className="text-sm text-foreground-600">
              刚刚上线的优质资源，第一时间为你呈现
            </p>
          </div>
          <Link
            to="/category/xuexi-ziliao"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestResources.map((res, index) => (
            <div
              key={res.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <ResourceCard resource={res} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}